// import 'helper/debug';
import './global.scss';
import '../190506-@shared/common';
import '../190506-@shared/pin-tuan-config';
import Vue from './setup';
import App from './App.vue';
import { init } from './service';

init().then(() => {
  new Vue({
    render: h => h(App),
  }).$mount('#root');
});
